import { COLORS } from '../../common/utils/icon/constants';
import { getIcon } from '../../common/utils/icon/icon';
const getStyles = notNeutral => `
  height: auto;
  ${notNeutral && 'margin-top: 2%'};
  width: ${notNeutral ? '56%' : '100%'};
`;
const configuration = {
  colors: [COLORS.blue, COLORS.white],
  getStyles,
  id: 'simple-visa'
};
export default type => getIcon({
  ...configuration,
  type
});
//# sourceMappingURL=icon.js.map